import { createSlice } from "@reduxjs/toolkit";
import {
  ACCENT_COLOR_HOVER,
  ACCENT_COLOR_MAIN,
  DEFAULT_ADD_COST_VALUE,
  DEFAULT_CENTER,
  DEFAULT_CURRENCY,
  DEFAULT_RADIUS,
  MAX_RADIUS,
  TAXI_COLUMN_ID,
} from "config/constants";
import { IAccentColors } from "config/types";
import { ITariff } from "store/api/types";
import { ILocation } from "pages/MapComponent/components/MapClickHandler/types";

interface ISettingsState {
  currency: string;
  addCostIncrementValue: number;
  apiVersion: string;
  cardPaymentPermitted: boolean;
  config: {
    taxiColumnId: number;
    accentColor: IAccentColors;
    tariffs: ITariff[] | null;
    radius: {
      defaultRadius: number;
      maxRadius: number;
    };
    cityCenter: ILocation;
  };
}

const initialState: ISettingsState = {
  currency: DEFAULT_CURRENCY,
  addCostIncrementValue: DEFAULT_ADD_COST_VALUE,
  apiVersion: "",
  cardPaymentPermitted: false,
  config: {
    taxiColumnId: TAXI_COLUMN_ID,
    accentColor: {
      main: ACCENT_COLOR_MAIN,
      hover: ACCENT_COLOR_HOVER,
    },
    tariffs: null,
    radius: {
      defaultRadius: DEFAULT_RADIUS,
      maxRadius: MAX_RADIUS,
    },
    cityCenter: DEFAULT_CENTER,
  },
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setCurrency: (state, { payload }) => {
      state.currency = payload;
    },
    setAddCostIncrementValue: (state, { payload }) => {
      state.addCostIncrementValue = payload;
    },
    setApiVersion: (state, { payload }) => {
      state.apiVersion = payload;
    },
    setCardPaymentPermitted: (state, { payload }) => {
      state.cardPaymentPermitted = payload;
    },
    setConfig: (state, { payload }) => {
      state.config.taxiColumnId = payload.TAXI_COLUMN_ID;
      state.config.accentColor = {
        main: payload.ACCENT_COLOR_MAIN,
        hover: payload.ACCENT_COLOR_HOVER,
      };
      state.config.tariffs = payload.TARIFFS;
      state.config.radius = {
        defaultRadius: payload.DEFAULT_RADIUS,
        maxRadius: payload.MAX_RADIUS,
      };
      state.config.cityCenter = payload.CITY_CENTER;
    },
  },
});

export const {
  setCurrency,
  setAddCostIncrementValue,
  setApiVersion,
  setCardPaymentPermitted,
  setConfig,
} = settingsSlice.actions;
export default settingsSlice.reducer;
